<p-toast></p-toast>

<section class="gps-page">
  <app-page-shell>

    <app-page-hero eyebrow="Fleet GPS" [title]="pageTitle()" [subtitle]="pageSubtitle()">
      <div nav class="gps-nav-tabs">
        <p-button label="Live" icon="pi pi-map-marker" [outlined]="page !== 'live'" routerLink="/fleet/gps"></p-button>
        @if (selectedVehicleId) {
          <p-button label="History" icon="pi pi-history" [outlined]="page !== 'history'" [routerLink]="['/fleet/gps/vehicles', selectedVehicleId, 'history']" [queryParams]="selectedSourceKey ? { sourceKey: selectedSourceKey } : {}"></p-button>
        }
        <p-button label="Providers" icon="pi pi-sitemap" [outlined]="page !== 'providers'" routerLink="/fleet/gps/providers"></p-button>
        <p-button label="Mappings" icon="pi pi-link" [outlined]="page !== 'mappings'" routerLink="/fleet/gps/mappings"></p-button>
        <p-button label="Geofences" icon="pi pi-map" [outlined]="page !== 'geofences'" routerLink="/fleet/gps/geofences"></p-button>
        <p-button label="Alerts" icon="pi pi-bell" [outlined]="page !== 'alerts'" routerLink="/fleet/gps/alerts"></p-button>
        <p-button label="Reports" icon="pi pi-chart-bar" [outlined]="page !== 'reports'" routerLink="/fleet/gps/reports"></p-button>
      </div>

      <div actions class="gps-hero-actions">
        <span class="sync-chip" [class.paused]="!pollingEnabled">
          <i class="pi" [class.pi-wifi]="pollingEnabled" [class.pi-pause-circle]="!pollingEnabled"></i>
          {{ pollingEnabled ? 'Polling' : 'Paused' }}
        </span>
        <p-button icon="pi pi-refresh" label="Refresh" severity="secondary" [outlined]="true" [loading]="isRefreshing" (onClick)="loadPageData()"></p-button>
        <p-button [icon]="pollingEnabled ? 'pi pi-pause' : 'pi pi-play'" [label]="pollingEnabled ? 'Pause' : 'Resume'" [outlined]="!pollingEnabled" (onClick)="togglePolling()"></p-button>
      </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="gpsMetrics()"></app-page-metric-strip>

    <app-page-search-panel
      title="GPS Filters"
      [activeFilters]="activeFilterCount()"
      [resultText]="filterResultText()"
      [collapsed]="false"
      (search)="loadPageData()"
      (clear)="clearFilters()">
      <div class="gps-filter-grid">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="gpsKeyword" pInputText type="text" [(ngModel)]="keyword" />
            <label for="gpsKeyword">Search</label>
          </p-iftaLabel>
        </p-inputGroup>

        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-database"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="gpsSource" [options]="sourceOptions()" [(ngModel)]="selectedSourceKey" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body" styleClass="w-full" (onChange)="onSourceChange()"></p-select>
            <label for="gpsSource">Source</label>
          </p-iftaLabel>
        </p-inputGroup>

        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-filter"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="gpsStatus" [options]="statusOptions" [(ngModel)]="selectedStatus" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="gpsStatus">Status</label>
          </p-iftaLabel>
        </p-inputGroup>

        @if (page === 'vehicle' || page === 'history') {
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-datePicker inputId="gpsHistoryRange" [(ngModel)]="historyRange" selectionMode="range" [showTime]="true" hourFormat="24" appendTo="body" styleClass="w-full" (onSelect)="onHistoryRangeChange()"></p-datePicker>
              <label for="gpsHistoryRange">History range</label>
            </p-iftaLabel>
          </p-inputGroup>
        }
      </div>
    </app-page-search-panel>

    @if (isLoading) {
      <div class="loading-state">
        <p-progressSpinner ariaLabel="Loading GPS workspace"></p-progressSpinner>
      </div>
    }

    @switch (page) {
      @case ('live') {
        <app-page-data-panel title="Live Control Tower" subtitle="Vehicle positions and event pulse." [resultText]="filterResultText()">
          <section class="control-tower">
            <div class="map-shell">
              <div class="map-status-bar">
                <span><i class="pi pi-circle-fill active-dot"></i>{{ metricActive() }} active</span>
                <span><i class="pi pi-circle-fill stale-dot"></i>{{ metricStale() }} stale</span>
                <span><i class="pi pi-circle-fill muted-dot"></i>{{ metricUnmapped() }} unmapped</span>
              </div>
              <div class="map-panel">
                <google-map height="100%" width="100%" [center]="mapCenter" [zoom]="mapZoom" [options]="mapOptions">
                  @for (marker of mapMarkers(); track marker.key) {
                    <map-marker [position]="marker.position" [options]="marker.options" [title]="selectedVehicleLabel(marker.vehicle.vehicleId)" (mapClick)="selectVehicle(marker.vehicle)"></map-marker>
                  }
                </google-map>
              </div>
            </div>

            <aside class="vehicle-rail">
              <div class="rail-header">
                <div>
                  <span class="section-kicker">Fleet</span>
                  <h2>Vehicles</h2>
                </div>
                <p-badge [value]="displayedVehicles().length.toString()" severity="info"></p-badge>
              </div>
              <div class="vehicle-list">
                @for (vehicle of displayedVehicles(); track vehicle.vehicleId + ':' + (vehicle.sourceKey || 'best')) {
                  <button type="button" class="vehicle-card" [class.active]="isVehicleSelected(vehicle)" (click)="selectVehicle(vehicle)" (dblclick)="openVehicle(vehicle)">
                    <span class="vehicle-card-main">
                      <span class="vehicle-icon"><i class="pi pi-truck"></i></span>
                      <span>
                        <strong>{{ selectedVehicleLabel(vehicle.vehicleId) }}</strong>
                        <small>{{ sourceName(vehicle.sourceKey) }}</small>
                      </span>
                    </span>
                    <p-tag [value]="statusLabel(vehicle.liveStatus)" [severity]="statusSeverity(vehicle.liveStatus)"></p-tag>
                    <span class="vehicle-meta">{{ speedLabel(vehicle.location) }} - {{ dateLabel(vehicle.location?.recordedAt) }}</span>
                  </button>
                } @empty {
                  <div class="empty-state">No vehicles match the selected filters.</div>
                }
              </div>
            </aside>
          </section>
        </app-page-data-panel>

        @if (selectedVehicleLive) {
          <section class="detail-grid">
            <app-page-data-panel title="Selected Vehicle">
              <div actions>
                <p-button icon="pi pi-external-link" label="Open" size="small" [outlined]="true" (onClick)="openVehicle(selectedVehicleLive)"></p-button>
                <p-button icon="pi pi-history" label="History" size="small" [outlined]="true" (onClick)="openVehicleHistory(selectedVehicleLive)"></p-button>
              </div>
              <div class="kv-grid">
                <div><span>Vehicle</span><strong>{{ selectedVehicleLabel(selectedVehicleLive.vehicleId) }}</strong></div>
                <div><span>Status</span><p-tag [value]="statusLabel(selectedVehicleLive.liveStatus)" [severity]="statusSeverity(selectedVehicleLive.liveStatus)"></p-tag></div>
                <div><span>Source</span><strong>{{ sourceName(selectedVehicleLive.sourceKey) }}</strong></div>
                <div><span>Provider</span><strong>{{ providerName(selectedVehicleLive.location?.providerCode) }}</strong></div>
                <div><span>Speed</span><strong>{{ speedLabel(selectedVehicleLive.location) }}</strong></div>
                <div><span>Ignition</span><strong>{{ selectedVehicleLive.location?.ignition === true ? 'On' : selectedVehicleLive.location?.ignition === false ? 'Off' : '-' }}</strong></div>
                <div><span>Coordinates</span><strong>{{ coordinateLabel(selectedVehicleLive.location) }}</strong></div>
                <div><span>Recorded</span><strong>{{ dateLabel(selectedVehicleLive.location?.recordedAt) }}</strong></div>
              </div>
            </app-page-data-panel>

            <app-page-data-panel title="Recent Events">
              <div class="event-list compact">
                @for (event of selectedVehicleLive.recentEvents || []; track event.id) {
                  <div class="event-row">
                    <p-tag [value]="event.eventType" [severity]="eventSeverity(event.eventType)"></p-tag>
                    <span>{{ dateLabel(event.eventTime) }}</span>
                    <strong>{{ speedLabel({ speedKph: event.speedKph }) }}</strong>
                  </div>
                } @empty {
                  <div class="empty-state">No recent events.</div>
                }
              </div>
            </app-page-data-panel>
          </section>
        }
      }

      @case ('vehicle') {
        <app-page-data-panel title="Vehicle Live Track" [resultText]="selectedVehicleLabel(selectedVehicleId)">
          <div actions>
            <p-button icon="pi pi-history" label="History Replay" [outlined]="true" [routerLink]="['/fleet/gps/vehicles', selectedVehicleId, 'history']" [queryParams]="selectedSourceKey ? { sourceKey: selectedSourceKey } : {}"></p-button>
          </div>
          <section class="vehicle-detail">
            <div class="map-shell">
              <div class="map-status-bar">
                <span><i class="pi pi-truck"></i>{{ selectedVehicleLabel(selectedVehicleId) }}</span>
                <span><i class="pi pi-database"></i>{{ sourceName(selectedVehicleLive?.sourceKey) }}</span>
              </div>
              <div class="map-panel detail-map">
                <google-map height="100%" width="100%" [center]="mapCenter" [zoom]="mapZoom" [options]="mapOptions">
                  @if (selectedVehicleLive?.location?.latitude && selectedVehicleLive?.location?.longitude) {
                    <map-marker [position]="selectedLiveMarkerPosition()" [options]="selectedVehicleMarkerOptions()" [title]="selectedVehicleLabel(selectedVehicleId)"></map-marker>
                  }
                  <map-polyline [path]="historyPath()" [options]="{ strokeColor: '#2563eb', strokeOpacity: 0.9, strokeWeight: 4 }"></map-polyline>
                </google-map>
              </div>
            </div>
            <div class="vehicle-summary">
              <p-tag [value]="statusLabel(selectedVehicleLive?.liveStatus)" [severity]="statusSeverity(selectedVehicleLive?.liveStatus)"></p-tag>
              <h2>{{ selectedVehicleLabel(selectedVehicleId) }}</h2>
              <div class="kv-grid one">
                <div><span>Source</span><strong>{{ sourceName(selectedVehicleLive?.sourceKey) }}</strong></div>
                <div><span>Provider</span><strong>{{ providerName(selectedVehicleLive?.location?.providerCode) }}</strong></div>
                <div><span>Device</span><strong>{{ selectedVehicleLive?.location?.providerDeviceId || '-' }}</strong></div>
                <div><span>Speed</span><strong>{{ speedLabel(selectedVehicleLive?.location) }}</strong></div>
                <div><span>Coordinates</span><strong>{{ coordinateLabel(selectedVehicleLive?.location) }}</strong></div>
                <div><span>Last point</span><strong>{{ dateLabel(selectedVehicleLive?.location?.recordedAt) }}</strong></div>
              </div>
            </div>
          </section>
        </app-page-data-panel>

        <section class="tables-grid">
          <app-page-data-panel title="Events" [resultText]="vehicleEvents.length + ' events'">
            <p-table [value]="vehicleEvents" [rows]="10" [paginator]="vehicleEvents.length > 10" styleClass="p-datatable-sm gps-table">
              <ng-template pTemplate="header">
                <tr><th>Event</th><th>Time</th><th>Speed</th><th>Source</th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-event>
                <tr>
                  <td><p-tag [value]="event.eventType" [severity]="eventSeverity(event.eventType)"></p-tag></td>
                  <td>{{ dateLabel(event.eventTime) }}</td>
                  <td>{{ speedLabel({ speedKph: event.speedKph }) }}</td>
                  <td>{{ sourceName(event.sourceKey, '-') }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="4"><div class="table-empty">No events in this range.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>

          <app-page-data-panel title="Route Trail" [resultText]="vehicleHistory.length + ' points'">
            <p-table [value]="vehicleHistory" [rows]="10" [paginator]="vehicleHistory.length > 10" styleClass="p-datatable-sm gps-table">
              <ng-template pTemplate="header">
                <tr><th>Recorded</th><th>Speed</th><th>Coordinates</th><th>Provider</th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-point>
                <tr>
                  <td>{{ dateLabel(point.recordedAt) }}</td>
                  <td>{{ speedLabel({ speedKph: point.speedKph }) }}</td>
                  <td>{{ point.latitude }}, {{ point.longitude }}</td>
                  <td>{{ providerName(point.providerCode) }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="4"><div class="table-empty">No route trail in this range.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>
        </section>
      }

      @case ('history') {
        <app-page-data-panel title="History Replay" subtitle="Route playback, coordinate trail, events, and derived alerts." [resultText]="replayTimeWindowLabel()">
          <section class="history-replay-layout">
            <div class="map-shell history-map-shell">
              <div class="map-status-bar">
                <span><i class="pi pi-truck"></i>{{ selectedVehicleLabel(selectedVehicleId) }}</span>
                <span><i class="pi pi-database"></i>{{ sourceName(selectedSourceKey || selectedVehicleLive?.sourceKey) }}</span>
                <span><i class="pi pi-map-marker"></i>{{ vehicleHistory.length }} points</span>
              </div>
              <div class="map-panel history-map">
                <google-map height="100%" width="100%" [center]="mapCenter" [zoom]="mapZoom" [options]="mapOptions">
                  <map-polyline [path]="historyPath()" [options]="{ strokeColor: '#0f766e', strokeOpacity: 0.92, strokeWeight: 5 }"></map-polyline>
                  @if (vehicleHistory.length) {
                    @if (pointPosition(vehicleHistory[0]); as startPosition) {
                      <map-marker [position]="startPosition" [options]="{ label: 'S', zIndex: 24 }" title="Start"></map-marker>
                    }
                    @if (pointPosition(vehicleHistory[vehicleHistory.length - 1]); as endPosition) {
                      <map-marker [position]="endPosition" [options]="{ label: 'E', zIndex: 25 }" title="End"></map-marker>
                    }
                  }
                  @if (replayMarkerPosition(); as replayPosition) {
                    <map-marker [position]="replayPosition" [options]="replayMarkerOptions()" [title]="selectedVehicleLabel(selectedVehicleId)"></map-marker>
                  }
                </google-map>
              </div>
            </div>

            <aside class="replay-panel">
              <div class="rail-header">
                <div>
                  <span class="section-kicker">Replay</span>
                  <h2>Playback Control</h2>
                </div>
                <p-tag [value]="replayPlaying ? 'Playing' : 'Paused'" [severity]="replayPlaying ? 'success' : 'secondary'"></p-tag>
              </div>

              <div class="replay-controls">
                <div class="replay-buttons">
                  <p-button [icon]="replayPlaying ? 'pi pi-pause' : 'pi pi-play'" [label]="replayPlaying ? 'Pause' : 'Play'" (onClick)="replayPlaying ? pauseReplay() : startReplay()" [disabled]="vehicleHistory.length < 2"></p-button>
                  <p-button icon="pi pi-undo" label="Reset" severity="secondary" [outlined]="true" (onClick)="resetReplay()" [disabled]="!vehicleHistory.length"></p-button>
                </div>

                <p-inputGroup>
                  <p-inputGroupAddon><i class="pi pi-bolt"></i></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-select inputId="replaySpeed" [options]="replaySpeeds" [(ngModel)]="replaySpeed" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" (onChange)="onReplaySpeedChange()"></p-select>
                    <label for="replaySpeed">Speed</label>
                  </p-iftaLabel>
                </p-inputGroup>

                <div class="replay-scrubber">
                  <div class="scrubber-meta">
                    <span>{{ replayIndex + 1 }} / {{ vehicleHistory.length || 0 }}</span>
                    <strong>{{ replayProgress() }}%</strong>
                  </div>
                  <input type="range" min="0" [max]="replayMaxIndex()" [value]="replayIndex" (input)="onReplayIndexChange($any($event.target).value)" [disabled]="!vehicleHistory.length" />
                </div>
              </div>

              <div class="kv-grid one replay-current">
                <div><span>Recorded</span><strong>{{ dateLabel(currentReplayPoint?.recordedAt) }}</strong></div>
                <div><span>Coordinates</span><strong>{{ coordinateLabel(currentReplayPoint) }}</strong></div>
                <div><span>Speed</span><strong>{{ speedLabel(currentReplayPoint) }}</strong></div>
                <div><span>Heading</span><strong>{{ currentReplayPoint?.headingDegrees ?? '-' }}</strong></div>
                <div><span>Provider</span><strong>{{ providerName(currentReplayPoint?.providerCode) }}</strong></div>
                <div><span>Device</span><strong>{{ currentReplayPoint?.providerDeviceId || '-' }}</strong></div>
              </div>
            </aside>
          </section>
        </app-page-data-panel>

        <section class="history-bottom-grid">
          <app-page-data-panel title="Coordinates" [resultText]="vehicleHistory.length + ' points'">
            <p-table [value]="vehicleHistory" [rows]="12" [paginator]="vehicleHistory.length > 12" styleClass="p-datatable-sm gps-table" [tableStyle]="{ 'min-width': '52rem' }">
              <ng-template pTemplate="header">
                <tr><th>#</th><th>Recorded</th><th>Latitude</th><th>Longitude</th><th>Speed</th><th>Heading</th><th>Source</th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-point let-rowIndex="rowIndex">
                <tr [class.current-history-row]="rowIndex === replayIndex">
                  <td>{{ rowIndex + 1 }}</td>
                  <td>{{ dateLabel(point.recordedAt) }}</td>
                  <td>{{ point.latitude ?? '-' }}</td>
                  <td>{{ point.longitude ?? '-' }}</td>
                  <td>{{ speedLabel(point) }}</td>
                  <td>{{ point.headingDegrees ?? '-' }}</td>
                  <td>{{ sourceName(point.sourceKey, '-') }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="7"><div class="table-empty">No GPS coordinates found for this period.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>

          <app-page-data-panel title="Events" [resultText]="vehicleEvents.length + ' events'">
            <p-table [value]="vehicleEvents" [rows]="12" [paginator]="vehicleEvents.length > 12" styleClass="p-datatable-sm gps-table" [tableStyle]="{ 'min-width': '42rem' }">
              <ng-template pTemplate="header">
                <tr><th>Event</th><th>Time</th><th>Speed</th><th>Coordinates</th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-event>
                <tr>
                  <td><p-tag [value]="event.eventType" [severity]="eventSeverity(event.eventType)"></p-tag></td>
                  <td>{{ dateLabel(event.eventTime) }}</td>
                  <td>{{ speedLabel(event) }}</td>
                  <td>{{ coordinateLabel(event) }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="4"><div class="table-empty">No vehicle events found for this period.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>

          <app-page-data-panel title="Derived Alerts" [resultText]="derivedAlerts().length + ' alerts'">
            <div class="event-list alert-feed">
              @for (event of derivedAlerts(); track event.id) {
                <div class="event-row alert-row">
                  <p-tag [value]="event.eventType" [severity]="eventSeverity(event.eventType)"></p-tag>
                  <span>{{ dateLabel(event.eventTime) }}</span>
                  <strong>{{ coordinateLabel(event) }}</strong>
                </div>
              } @empty {
                <div class="empty-state">No derived alerts for this period.</div>
              }
            </div>
          </app-page-data-panel>
        </section>
      }

      @case ('providers') {
        <section class="providers-layout">
          <app-page-data-panel title="Provider Catalog" [resultText]="providers.length + ' providers'">
            <div actions>
              <p-button icon="pi pi-plus" label="New Connector" (onClick)="openNewConnectorDialog()"></p-button>
            </div>
            <div class="provider-grid">
              @for (provider of providers; track provider.providerCode) {
                <article class="provider-card">
                  <div class="provider-card-head">
                    @if (providerLogo(provider.providerCode); as logoSrc) {
                      <span class="provider-logo-frame">
                        <img class="provider-logo" [src]="logoSrc" [alt]="displayGpsName(provider.displayName) + ' logo'" (error)="onProviderLogoError(provider.providerCode)" />
                      </span>
                    } @else {
                      <span class="provider-icon"><i class="pi pi-sitemap"></i></span>
                    }
                    <div>
                      <h2>{{ displayGpsName(provider.displayName) }}</h2>
                      <p>{{ displayGpsName(provider.providerCode) }}</p>
                    </div>
                  </div>
                  <p-tag [value]="provider.providerStatus" [severity]="statusSeverity(provider.providerStatus)"></p-tag>
                  <dl>
                    <div><dt>Auth</dt><dd>{{ provider.authType || '-' }}</dd></div>
                    <div><dt>Default poll</dt><dd>{{ provider.defaultPollingIntervalSeconds || 60 }} sec</dd></div>
                  </dl>
                  <div class="provider-card-footer">
                    <span class="provider-setup-hint">{{ providerSetupHint(provider) }}</span>
                    @if (canConfigureProvider(provider)) {
                      <p-button icon="pi pi-sliders-h" [label]="providerSetupLabel(provider)" size="small" (onClick)="configureProvider(provider)"></p-button>
                    } @else {
                      <span class="provider-setup-status"><i class="pi pi-info-circle"></i>{{ providerSetupLabel(provider) }}</span>
                    }
                  </div>
                </article>
              }
            </div>
          </app-page-data-panel>

          <app-page-data-panel class="wide" title="Connectors" [resultText]="connectors.length + ' configured'">
            @if (connectors.length) {
              <p-table [value]="connectors" [rows]="10" [paginator]="connectors.length > 10" styleClass="p-datatable-sm gps-table" [tableStyle]="{ 'min-width': '56rem' }">
                <ng-template pTemplate="header">
                  <tr><th>Name</th><th>Provider</th><th>Status</th><th>Last Sync</th><th>Actions</th></tr>
                </ng-template>
                <ng-template pTemplate="body" let-connector>
                  <tr>
                    <td><strong>{{ displayGpsName(connector.displayName) }}</strong><br><small>{{ connector.baseUrl || '-' }}</small></td>
                    <td>{{ providerName(connector.providerCode) }}</td>
                    <td><p-tag [value]="connector.connectorStatus || (connector.active ? 'ACTIVE' : 'DISABLED')" [severity]="statusSeverity(connector.connectorStatus || (connector.active ? 'ACTIVE' : 'DISABLED'))"></p-tag></td>
                    <td>{{ dateLabel(connector.lastSyncCompletedAt) }}<br><small>{{ connector.lastSyncMessage || connector.lastSyncStatus || '-' }}</small></td>
                    <td class="table-actions">
                      <p-button icon="pi pi-pencil" label="Edit" size="small" [outlined]="true" (onClick)="editConnector(connector)"></p-button>
                      <p-button icon="pi pi-bolt" label="Test" size="small" severity="secondary" [outlined]="true" (onClick)="testConnector(connector)"></p-button>
                      <p-button icon="pi pi-link" label="Map Devices" size="small" severity="success" [outlined]="true" (onClick)="openConnectorMappings(connector)"></p-button>
                      <p-button icon="pi pi-refresh" label="Sync" size="small" severity="success" [outlined]="true" (onClick)="syncConnector(connector)"></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            } @else {
              <div class="connector-empty-state">
                <span class="provider-icon large"><i class="pi pi-plug"></i></span>
                <div>
                  <h3>Connect your GPS provider</h3>
                  <p>Choose an available provider above to add its endpoint and credentials. Then test the connection and map its GPS devices to your fleet.</p>
                </div>
                <p-button icon="pi pi-plus" label="Configure a connector" (onClick)="openNewConnectorDialog()"></p-button>
              </div>
            }
          </app-page-data-panel>
        </section>
      }

      @case ('mappings') {
        <section class="mapping-layout">
          <app-page-data-panel class="wide" title="Mapping Scope" subtitle="Choose the connector and link provider devices to owned or rented vehicles." [resultText]="selectedConnectorName()">
            <div actions>
              <p-button icon="pi pi-plus" label="New Mapping" (onClick)="openNewMappingDialog()" [disabled]="!selectedConnectorId"></p-button>
            </div>
            <div class="mapping-scope-grid">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                <p-iftaLabel>
                  <p-select inputId="mappingConnectorScope" [options]="connectorOptions()" [(ngModel)]="selectedConnectorId" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" (onChange)="onConnectorChange()"></p-select>
                  <label for="mappingConnectorScope">Connector</label>
                </p-iftaLabel>
              </p-inputGroup>
              <div class="scope-summary">
                <span><i class="pi pi-qrcode"></i>{{ unmappedGpsDevices.length }} unmapped GPS devices</span>
                <span><i class="pi pi-truck"></i>{{ unmappedLogilinkVehicles.length }} unmapped LogiLink vehicles</span>
                <span><i class="pi pi-link"></i>{{ mappings.length }} active mappings</span>
              </div>
            </div>
          </app-page-data-panel>

          <section class="mapping-insights-grid">
            <app-page-data-panel title="Unmapped GPS Devices" subtitle="Devices reported by the selected GPS connector but not linked to a vehicle." [resultText]="unmappedGpsDevices.length + ' devices'">
              <div class="candidate-list">
                @for (device of unmappedGpsDevices; track device.providerDeviceId) {
                  <button type="button" class="candidate-card" (click)="openDeviceMappingDialog(device)">
                    <span class="candidate-icon"><i class="pi pi-qrcode"></i></span>
                    <span>
                      <strong>{{ device.providerDeviceId }}</strong>
                      <small>{{ device.providerDeviceName || providerName(device.providerCode) }}</small>
                      <small>{{ coordinateLabel(device) }} - {{ dateLabel(device.recordedAt) }}</small>
                    </span>
                    <i class="pi pi-arrow-right"></i>
                  </button>
                } @empty {
                  <div class="empty-state">No unmapped provider devices for this connector.</div>
                }
              </div>
            </app-page-data-panel>

            <app-page-data-panel title="Unmapped LogiLink Vehicles" subtitle="Owned and rented vehicles not linked to the selected GPS connector." [resultText]="unmappedLogilinkVehicles.length + ' vehicles'">
              <div class="candidate-list">
                @for (vehicle of unmappedLogilinkVehicles; track vehicle.value) {
                  <button type="button" class="candidate-card" (click)="openVehicleMappingDialog(vehicle)">
                    <span class="candidate-icon vehicle"><i class="pi pi-truck"></i></span>
                    <span>
                      <strong>{{ vehicle.plateNumber || ('Vehicle ' + vehicle.value) }}</strong>
                      <small>{{ vehicle.registrationNumber || '-' }}</small>
                      <small>{{ vehicle.source }} fleet</small>
                    </span>
                    <i class="pi pi-arrow-right"></i>
                  </button>
                } @empty {
                  <div class="empty-state">All owned and rented vehicles are mapped for this connector.</div>
                }
              </div>
            </app-page-data-panel>
          </section>

          <app-page-data-panel class="wide" title="Mapped Devices" [resultText]="mappings.length + ' mappings'">
            <p-table [value]="mappings" [rows]="12" [paginator]="mappings.length > 12" styleClass="p-datatable-sm gps-table" [tableStyle]="{ 'min-width': '48rem' }">
              <ng-template pTemplate="header">
                <tr><th>Device</th><th>Vehicle</th><th>Connector</th><th>Status</th><th></th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-mapping>
                <tr>
                  <td><strong>{{ mapping.providerDeviceId }}</strong><br><small>{{ mapping.providerDeviceName || '-' }}</small></td>
                  <td>{{ mapping.plateNumber || selectedVehicleLabel(mapping.vehicleId) }}</td>
                  <td>{{ connectorName(mapping.connectorId || selectedConnectorId) }}</td>
                  <td><p-tag [value]="mapping.active ? 'ACTIVE' : 'DISABLED'" [severity]="statusSeverity(mapping.active ? 'ACTIVE' : 'DISABLED')"></p-tag></td>
                  <td><p-button icon="pi pi-ban" label="Deactivate" size="small" severity="danger" [outlined]="true" [disabled]="!mapping.active" (onClick)="deactivateMapping(mapping)"></p-button></td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="5"><div class="table-empty">No mapped devices.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>
        </section>
      }

      @case ('geofences') {
        <section class="ops-layout">
          <app-page-data-panel title="Geofence Map">
            <div class="map-shell">
              <div class="map-status-bar">
                <span><i class="pi pi-map"></i>Geofence workspace</span>
                <span><i class="pi pi-truck"></i>{{ displayedVehicles().length }} vehicles</span>
              </div>
              <div class="map-panel ops-map">
                <google-map height="100%" width="100%" [center]="mapCenter" [zoom]="mapZoom" [options]="mapOptions">
                  @for (marker of mapMarkers(); track marker.key) {
                    <map-marker [position]="marker.position" [options]="marker.options" [title]="selectedVehicleLabel(marker.vehicle.vehicleId)"></map-marker>
                  }
                </google-map>
              </div>
            </div>
          </app-page-data-panel>

          <app-page-data-panel title="Geofence Draft">
            <div class="form-grid one-column">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
                <p-iftaLabel><input id="geofenceName" pInputText [(ngModel)]="draftGeofence.name" /><label for="geofenceName">Name</label></p-iftaLabel>
              </p-inputGroup>

              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
                <p-iftaLabel><p-select inputId="geofenceShape" [options]="geofenceShapeOptions" [(ngModel)]="draftGeofence.shapeType" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select><label for="geofenceShape">Shape</label></p-iftaLabel>
              </p-inputGroup>

              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
                <p-iftaLabel><input id="geofenceAssign" pInputText [(ngModel)]="draftGeofence.assignedTo" /><label for="geofenceAssign">Assignment</label></p-iftaLabel>
              </p-inputGroup>

              <label class="toggle-row"><p-checkbox [(ngModel)]="draftGeofence.active" [binary]="true"></p-checkbox><span>Active</span></label>
            </div>
            <div class="empty-state left">No geofences saved.</div>
          </app-page-data-panel>
        </section>
      }

      @case ('alerts') {
        <section class="tables-grid">
          <app-page-data-panel title="Rule Draft">
            <div class="form-grid one-column">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
                <p-iftaLabel><input id="alertName" pInputText [(ngModel)]="draftAlertRule.name" /><label for="alertName">Rule name</label></p-iftaLabel>
              </p-inputGroup>

              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-bell"></i></p-inputGroupAddon>
                <p-iftaLabel><p-select inputId="alertEvent" [options]="alertEventOptions" [(ngModel)]="draftAlertRule.eventType" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select><label for="alertEvent">Event</label></p-iftaLabel>
              </p-inputGroup>

              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-exclamation-triangle"></i></p-inputGroupAddon>
                <p-iftaLabel><input id="alertSeverity" pInputText [(ngModel)]="draftAlertRule.severity" /><label for="alertSeverity">Severity</label></p-iftaLabel>
              </p-inputGroup>

              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-gauge"></i></p-inputGroupAddon>
                <p-iftaLabel><p-inputNumber inputId="alertThreshold" [(ngModel)]="draftAlertRule.threshold" [useGrouping]="false" styleClass="w-full"></p-inputNumber><label for="alertThreshold">Threshold</label></p-iftaLabel>
              </p-inputGroup>

              <label class="toggle-row"><p-checkbox [(ngModel)]="draftAlertRule.enabled" [binary]="true"></p-checkbox><span>Enabled</span></label>
            </div>
            <div class="empty-state left">No alert rules saved.</div>
          </app-page-data-panel>

          <app-page-data-panel title="Live Event Inbox">
            <p-table [value]="selectedVehicleLive?.recentEvents || []" styleClass="p-datatable-sm gps-table" [tableStyle]="{ 'min-width': '42rem' }">
              <ng-template pTemplate="header">
                <tr><th>Event</th><th>Vehicle</th><th>Time</th><th>Source</th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-event>
                <tr>
                  <td><p-tag [value]="event.eventType" [severity]="eventSeverity(event.eventType)"></p-tag></td>
                  <td>{{ event.vehicleId }}</td>
                  <td>{{ dateLabel(event.eventTime) }}</td>
                  <td>{{ sourceName(event.sourceKey, '-') }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="4"><div class="table-empty">No live events selected.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>
        </section>
      }

      @case ('reports') {
        <section class="report-grid">
          <article class="report-card"><i class="pi pi-route"></i><span>Route Trail</span><strong>{{ vehicleHistory.length }}</strong><p>Loaded points</p></article>
          <article class="report-card"><i class="pi pi-clock"></i><span>Signal Review</span><strong>{{ metricStale() }}</strong><p>Stale assets</p></article>
          <article class="report-card"><i class="pi pi-shield"></i><span>Mapping Gaps</span><strong>{{ metricUnmapped() }}</strong><p>Open mappings</p></article>
          <article class="report-card"><i class="pi pi-sitemap"></i><span>Connectors</span><strong>{{ connectors.length }}</strong><p>Configured sources</p></article>
        </section>
      }
    }

    <p-dialog
      header="Manual Mapping"
      [(visible)]="mappingDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: 'min(72rem, 96vw)' }"
      [breakpoints]="{ '960px': '96vw' }"
      styleClass="gps-connector-dialog gps-mapping-dialog">
      <section class="connector-dialog-body">
        <aside class="connector-dialog-summary">
          <span class="provider-icon large"><i class="pi pi-link"></i></span>
          <div>
            <span class="section-kicker">Device Mapping</span>
            <h3>{{ selectedConnectorName() }}</h3>
            <p>Link one provider-side GPS device to one owned or rented LogiLink vehicle for the selected connector.</p>
          </div>
          <div class="connector-dialog-facts">
            <div><span>GPS device</span><strong>{{ mappingForm.providerDeviceId || '-' }}</strong></div>
            <div><span>Vehicle</span><strong>{{ selectedVehicleLabel(mappingForm.vehicleId) }}</strong></div>
            <div><span>Status</span><strong>{{ mappingForm.active ? 'Active' : 'Disabled' }}</strong></div>
          </div>
        </aside>

        <div class="form-grid connector-dialog-grid">
          <p-inputGroup class="connector-wide-field">
            <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="dialogMappingConnector" [options]="connectorOptions()" [(ngModel)]="selectedConnectorId" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" (onChange)="onConnectorChange()"></p-select>
              <label for="dialogMappingConnector">Connector</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-qrcode"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="dialogProviderDeviceId" pInputText [(ngModel)]="mappingForm.providerDeviceId" />
              <label for="dialogProviderDeviceId">Provider device ID</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="dialogProviderDeviceName" pInputText [(ngModel)]="mappingForm.providerDeviceName" />
              <label for="dialogProviderDeviceName">Provider device name</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup class="connector-wide-field">
            <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="dialogMappedVehicle" [options]="vehicleDropdownOptions()" [(ngModel)]="mappingForm.vehicleId" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" appendTo="body" styleClass="w-full" (onChange)="onMappingVehicleChange()"></p-select>
              <label for="dialogMappedVehicle">Owned / rented vehicle</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup class="connector-wide-field">
            <p-inputGroupAddon><i class="pi pi-credit-card"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="dialogMappedPlate" pInputText [(ngModel)]="mappingForm.plateNumber" />
              <label for="dialogMappedPlate">Plate number</label>
            </p-iftaLabel>
          </p-inputGroup>

          <label class="toggle-row connector-wide-field">
            <p-checkbox [(ngModel)]="mappingForm.active" [binary]="true"></p-checkbox>
            <span>Active</span>
          </label>
        </div>
      </section>

      <ng-template pTemplate="footer">
        <div class="dialog-footer-actions">
          <p-button icon="pi pi-refresh" label="Reset" severity="secondary" [outlined]="true" (onClick)="resetMappingForm()"></p-button>
          <span class="footer-spacer"></span>
          <p-button icon="pi pi-times" label="Cancel" severity="secondary" [outlined]="true" (onClick)="closeMappingDialog()"></p-button>
          <p-button icon="pi pi-save" label="Save Mapping" (onClick)="saveMapping()" [disabled]="!selectedConnectorId || !mappingForm.providerDeviceId || !mappingForm.vehicleId"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      [header]="connectorForm.id ? 'Edit Connector' : 'New Connector'"
      [(visible)]="connectorDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: 'min(76rem, 96vw)' }"
      [breakpoints]="{ '960px': '96vw' }"
      styleClass="gps-connector-dialog">
      <section class="connector-dialog-body">
        <aside class="connector-dialog-summary">
          @if (providerLogo(connectorForm.providerCode); as logoSrc) {
            <span class="provider-logo-frame large">
              <img class="provider-logo provider-logo-large" [src]="logoSrc" [alt]="displayGpsName(providerName(connectorForm.providerCode)) + ' logo'" (error)="onProviderLogoError(connectorForm.providerCode)" />
            </span>
          } @else {
            <span class="provider-icon large"><i class="pi pi-sitemap"></i></span>
          }
          <div>
            <span class="section-kicker">Marketplace Connector</span>
            <h3>{{ displayGpsName(providerName(connectorForm.providerCode)) }}</h3>
            <p>Company context is applied automatically from the current session. Add provider credentials and sync settings here.</p>
          </div>
          <div class="connector-dialog-facts">
            <div><span>Provider status</span><strong>{{ selectedProviderAllowsActivation() ? 'Active' : 'Not active' }}</strong></div>
            <div><span>Sync mode</span><strong>{{ connectorForm.syncMode || 'POLLING' }}</strong></div>
            <div><span>Polling</span><strong>{{ connectorForm.pollingIntervalSeconds || 60 }} sec</strong></div>
          </div>
          @if (connectorForm.id) {
            <small>Leave token blank to keep the stored credential.</small>
          }
        </aside>

        <div class="form-grid connector-dialog-grid">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="connectorName" pInputText [(ngModel)]="connectorForm.displayName" />
              <label for="connectorName">Display name</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="connectorProvider" [options]="providerOptions()" [(ngModel)]="connectorForm.providerCode" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
              <label for="connectorProvider">Provider</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup class="connector-wide-field">
            <p-inputGroupAddon><i class="pi pi-globe"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="connectorBaseUrl" pInputText [(ngModel)]="connectorForm.baseUrl" />
              <label for="connectorBaseUrl">Base URL</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-sync"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="connectorSyncMode" [options]="syncModeOptions" [(ngModel)]="connectorForm.syncMode" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
              <label for="connectorSyncMode">Sync mode</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-clock"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-inputNumber inputId="connectorInterval" [(ngModel)]="connectorForm.pollingIntervalSeconds" [min]="30" [useGrouping]="false" styleClass="w-full"></p-inputNumber>
              <label for="connectorInterval">Polling seconds</label>
            </p-iftaLabel>
          </p-inputGroup>

          @if (selectedProviderHasHttpConfiguration()) {
            <div class="connector-credentials connector-wide-field">
              <div class="connector-credentials-heading">
                <i class="pi pi-shield"></i>
                <div><strong>Connection credentials</strong><small>Add a bearer token or an API-key header. Leave either method blank if the provider does not use it.</small></div>
              </div>
              <div class="connector-credentials-grid">
                <p-inputGroup>
                  <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input id="connectorPositionsPath" pInputText [(ngModel)]="connectorCredentials.positionsPath" />
                    <label for="connectorPositionsPath">Positions path (optional)</label>
                  </p-iftaLabel>
                </p-inputGroup>
                <p-inputGroup>
                  <p-inputGroupAddon><i class="pi pi-key"></i></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input id="connectorBearerToken" pInputText type="password" [(ngModel)]="connectorCredentials.bearerToken" />
                    <label for="connectorBearerToken">Bearer token</label>
                  </p-iftaLabel>
                </p-inputGroup>
                <p-inputGroup>
                  <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input id="connectorApiKeyHeader" pInputText [(ngModel)]="connectorCredentials.apiKeyHeader" />
                    <label for="connectorApiKeyHeader">API-key header</label>
                  </p-iftaLabel>
                </p-inputGroup>
                <p-inputGroup>
                  <p-inputGroupAddon><i class="pi pi-key"></i></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input id="connectorApiKeyValue" pInputText type="password" [(ngModel)]="connectorCredentials.apiKeyValue" />
                    <label for="connectorApiKeyValue">API-key value</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>
            </div>
          }

          <label class="toggle-row connector-wide-field">
            <p-checkbox [(ngModel)]="connectorForm.active" [binary]="true" [disabled]="!selectedProviderAllowsActivation()"></p-checkbox>
            <span>Active</span>
          </label>
        </div>
      </section>

      <ng-template pTemplate="footer">
        <div class="dialog-footer-actions">
          <p-button icon="pi pi-refresh" label="Reset" severity="secondary" [outlined]="true" (onClick)="resetConnectorForm()"></p-button>
          <span class="footer-spacer"></span>
          <p-button icon="pi pi-times" label="Cancel" severity="secondary" [outlined]="true" (onClick)="closeConnectorDialog()"></p-button>
          <p-button icon="pi pi-save" label="Save Connector" (onClick)="saveConnector()" [disabled]="!connectorForm.displayName || !connectorForm.providerCode || (selectedProviderHasHttpConfiguration() && !connectorForm.baseUrl)"></p-button>
        </div>
      </ng-template>
    </p-dialog>
  </app-page-shell>
</section>
